import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import DashboardHeader from '../../components/dasboardHeader/index.vue'
import SideNav from '../../components/sideNavBar/index.vue'
import UserService from '../../services/UserService'
import chart from '../../charts/chart'
// import Shepherd from 'shepherd.js'

export default {
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  data () {
    return {
      statsData: '',
      jobStats: '',
      startD: 'dd/mm/yy',
      endD: 'dd/mm/yy',
      chartdata: {
        // labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        // datasets: [
        //   {
        //     label: 'Data One',
        //     backgroundColor: '#f87279',
        //     data: [40, 39, 10, 40, 39, 80, 40]
        //   }
        // ]
        labels: [],
        datasets: [
          {
            label: 'Jobs Posted',
            backgroundColor: '#f87279',
            data: []
          }
        ]
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [{
            gridLines: {
              display: true
            }
          }]
        },
        responsive: true,
        maintainAspectRatio: false
      },
      chartDataset: []
    }
  },
  components: {
    DashboardHeader,
    SideNav,
    chart
  },
  async mounted () {
    // code of segment integration
    window.analytics.identify('Dashboard', {
      path: '/dashboard/'
    })
    // window.analytics.page('Dashboard')
    this.statsData = await UserService.getStats()
    this.jobStats = JSON.parse(this.statsData)
    // this.endD = new Date().toISOString().slice(0, 10)
    this.endD = 'yyyy-MM-dd'
    const date = new Date()
    date.setMonth(date.getMonth() - 1)
    // this.startD = date.toISOString().slice(0, 10)
    this.startD = 'yyyy-MM-dd'
    this.filter()
    // const graphData = this.statsData.getStatisticData
    // console.log(this.statsData)
    // const tour = new Shepherd.Tour({
    //   useModalOverlay: true,
    //   defaultStepOptions: {
    //     cancelIcon: {
    //       enabled: false
    //     },
    //     scrollTo: {
    //       behavior: 'smooth',
    //       block: 'center'
    //     },
    //     arrow: false,
    //     modalOverlayOpeningPadding: 10
    //   }
    // })
    // tour.addStep({
    //   id: 'tour_step1',
    //   attachTo: { element: '.step1', on: 'top' },
    //   text: '<button class="skipButton" id="skipButton">Skip Tour</button><br>Welcome to jobizo - a platform to post a job for medical staff',
    //   buttons: [
    //     {
    //       text: 'Skip',
    //       action () {
    //         localStorage.setItem('tourToken', JSON.stringify({
    //           userOnBoardingStatus: 'yes'
    //         }))
    //         location.reload()
    //       }
    //     },
    //     {
    //       text: 'Next >>',
    //       action () {
    //         return this.next()
    //       }
    //     }
    //   ]
    // })
    // tour.addStep({
    //   id: 'tour_step2',
    //   attachTo: { element: '.step2', on: 'top' },
    //   text: 'Click here to post a job for hiring verified professionals',
    //   buttons: [
    //     {
    //       text: '<p style="position:absolute;top:0;right:0;">Skip</p>',
    //       action () {
    //         localStorage.setItem('tourToken', JSON.stringify({
    //           userOnBoardingStatus: 'yes'
    //         }))
    //         location.reload()
    //       }
    //     },
    //     {
    //       text: '<< Back',
    //       action () {
    //         return this.back()
    //       }
    //     },
    //     {
    //       text: 'Next >>',
    //       action () {
    //         tour.cancel('tour_step1')
    //         window.location.href = '/#/mini_job'
    //         // write backend code to send user onBoarding status true here
    //         return this.next()
    //       }
    //     }
    //   ]
    // })
    // if (JSON.parse(localStorage.getItem('tourToken')).userOnBoardingStatus === 'no') {
    //   tour.start()
    // }
  },
  methods: {
    getDate (data) {
      // const date = parseInt(data)
      const res = Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      }).format(new Date(data))
      // console.log(res)
      return res
    },
    async filter () {
      const data = await UserService.getStatisticData(this.startD, this.endD)
      const arr = data.sort(function (a, b) {
        return new Date(a.x) - new Date(b.x)
      })
      const xArr = []
      const yArr = []
      arr.forEach(d => {
        xArr.push(this.getDate(d.x))
        yArr.push(d.y)
      })
      // console.log(xArr)
      // console.log(yArr)
      this.chartdata.labels = xArr
      // this.$set(this.chartdata, 'labels', xArr)
      // this.$set(this.chartdata.datasets[0], 'data', yArr)
      this.chartdata.datasets[0].data = yArr
      this.chartDataset = yArr
      // console.log('chart', this.chartdata)
    }
  }
}
